<template>
  <div id="conteneurEleve">
    <Toast />
    <HeaderHome :user="this.$store.state.user.prenom"/>
    <!-- PAGE BODY -->
    <main class="page-main">
      <div class="page-header">
        <div class="page-header-left">
          <h1 class="page-title">Liste des élèves</h1>
          <p class="page-subtitle">Gestion et suivi de tous vos élèves inscrits</p>
        </div>
      </div>

      <div class="eleves-layout">

        <!-- LEFT: filters + table -->
        <div class="eleves-left">

          <!-- Filters row -->
          <div class="eleves-filters">
            <div class="eleves-search search-wrap">
              <svg width="16" height="16" fill="none" viewBox="0 0 24 24" class="search-icon">
                <circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="1.5"/>
                <path d="M21 21l-4.35-4.35" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              <SimpleTypeahead
                id="typeahead_id"
                :key="typeaheadKey"
                placeholder="Rechercher un élève..."
                :items="elevesName"
                :minInputLength="1"
                :itemProjection="(item) => { return item.fullname; }"
                @selectItem="selectItem"
                class="search-input"
              />
            </div>

            <button class="btn-cancel" @click="cancelSearch" v-if="cancelS == true">
              <i class="pi pi-times" style="font-size: 0.75rem"></i>
              Effacer
            </button>

            <select class="filter-select" name="formStep" v-model="dossier.step" @change="changeModeForm()">
              <option value="">Étape (tous)</option>
              <option value="1">1/5</option>
              <option value="2">2/5</option>
              <option value="3">3/5</option>
              <option value="4">4/5</option>
              <option value="5">5/5</option>
            </select>

            <select class="filter-select" name="statut" v-model="dossier.statut" @change="changeMode()">
              <option value="">Dossier (tous)</option>
              <option value="non paye">Non Payé</option>
              <option value="incomplet">Incomplet</option>
              <option value="validées">Validées</option>
              <option value="a traiter">À traiter</option>
              <option value="saisi">Saisi</option>
              <option value="enregistrer">Enregistrer</option>
            </select>

            <select class="filter-select" name="code" v-model="dossier.code" @change="changeModeCode()">
              <option value="">Code (tous)</option>
              <option value="non paye">Non Payé</option>
              <option value="paye">Payé</option>
              <option value="obtenu">Obtenu</option>
            </select>

            <router-link to="/ListeArchive" class="btn-archive-toggle">
              <svg width="14" height="14" fill="none" viewBox="0 0 24 24">
                <path d="M21 8v13H3V8M1 3h22v5H1zM10 12h4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Archive
            </router-link>
          </div>

          <!-- Table -->
          <div class="table-wrap">
            <DataTable
              :value="this.Elevesagence"
              :rows="7"
              v-model:filters="filters"
              v-model:selection="selectedItem"
              selectionMode="single"
              filterDisplay="menu"
              responsiveLayout="scroll"
              :globalFilterFields="['date','nom','prenom','Dossier.social','Dossier.lycee','contrat.tab']"
              dataKey="id"
              @click="onSelected"
            >
              <Column field="dateInsc" header="Date" [sortOrder]="-1" style="min-width: 5rem"></Column>
              <Column field="nom" header="Nom" style="min-width: 5rem"></Column>
              <Column field="prenom" header="Prénom" style="min-width: 6rem"></Column>
              <Column field="stepForm" header="Form." style="min-width: 6rem"></Column>
              <Column field="statutDossier" header="Dossier" style="min-width: 6rem"></Column>
              <Column field="code" header="Code" style="min-width: 6rem"></Column>
              <Column :exportable="false" style="min-width: 4rem">
                <template #body="slotProps">
                  <button class="row-del-btn" @click="deleteUtilisateur(slotProps.data.id)">
                    <i class="pi pi-times" style="font-size: 0.75rem"></i>
                  </button>
                </template>
              </Column>
              <Column header="Archiver" :exportable="false" style="min-width: 5rem">
                <template #body="slotProps">
                  <Checkbox :binary="true" @click="archiveEleve(slotProps.data.id)" />
                </template>
              </Column>
            </DataTable>
            <Paginator v-model:first="currentPage" :rows="10" :totalRecords="countEleves" @page="onPaginate" class="table-paginator"></Paginator>
          </div>
        </div>

        <!-- RIGHT: detail panel -->
        <div class="eleve-detail-panel">

          <!-- Empty state -->
          <div v-if="this.selectedItem === null" class="eleve-detail-empty">
            <svg width="40" height="40" fill="none" viewBox="0 0 24 24" style="color:#94a3b8; margin-bottom: 12px">
              <circle cx="12" cy="8" r="4" stroke="currentColor" stroke-width="1.5"/>
              <path d="M4 20c0-4 3.582-7 8-7s8 3 8 7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
            <p>Cliquez sur un élève<br>pour afficher ses informations</p>
          </div>

          <template v-if="this.selectedItem != null">
            <template v-if="this.showPaiement != true">

              <!-- Head -->
              <div class="eleve-detail-head">
                <div class="eleve-detail-head-top">
                  <div class="eleve-detail-name-block">
                    <div class="eleve-detail-name">{{ selectedItem.nom }} {{ selectedItem.prenom }}</div>
                    <div class="eleve-detail-phone">{{ selectedItem.telephone }}</div>
                  </div>
                </div>
                <div class="eleve-detail-tags">
                  <template v-if="this.selectedItem.newContract == 'null'">
                    <span class="tag tag-red">Contrat non créé</span>
                  </template>
                  <template v-if="this.selectedItem.newContract == 'wait'">
                    <span class="tag tag-amber" @click="showContrats()" style="cursor:pointer">Contrat en attente</span>
                  </template>
                  <template v-if="this.selectedItem.newContract == 'valide'">
                    <span class="tag tag-blue">Contrat validé</span>
                  </template>
                  <span class="tag tag-amber" v-if="selectedItem.numNeph">{{ selectedItem.numNeph }}</span>
                  <span class="tag tag-green" v-if="selectedItem.codeObtenu">Code obtenu</span>
                  <span class="tag tag-pink" v-if="selectedItem.examConduite">Exam conduite obtenu</span>
                </div>
              </div>

              <!-- Body -->
              <div class="eleve-detail-body">

                <!-- Info grid -->
                <div class="eleve-info-grid">
                  <div class="eleve-info-item">
                    <div class="info-label">Email</div>
                    <div class="eleve-info-val">{{ selectedItem.email }}</div>
                  </div>
                  <div class="eleve-info-item">
                    <div class="info-label">Adresse</div>
                    <div class="eleve-info-val">
                      {{ selectedItem.Dossier.adresse }}
                      {{ selectedItem.Dossier.cp }}
                      {{ selectedItem.Dossier.ville }}
                    </div>
                  </div>
                  <div class="eleve-info-item">
                    <div class="info-label">Boîte Véhicule</div>
                    <div class="eleve-info-val">{{ selectedItem.boite }}</div>
                  </div>
                  <div class="eleve-info-item">
                    <div class="info-label">Prévoir AAC</div>
                    <div class="eleve-info-val">
                      <template v-if="selectedItem.Dossier.prevoitAac">OUI</template>
                      <template v-else>NON</template>
                    </div>
                  </div>
                </div>

                <!-- Actions -->
                <div class="eleve-section-title">Actions</div>
                <div class="eleve-actions-grid">
                  <button @click="selectFormModal()" class="action-btn action-btn--blue">
                    <i class="pi pi-file" style="font-size:0.85rem"></i> Formulaire
                  </button>
                  <button @click="solde" class="action-btn action-btn--teal">
                    <i class="pi pi-wallet" style="font-size:0.85rem"></i> Solde
                  </button>
                  <button @click="goToDossier" class="action-btn action-btn--amber">
                    <i class="pi pi-folder" style="font-size:0.85rem"></i> Dossier
                  </button>
                </div>

                <!-- Agence -->
                <div class="eleve-section-title">Agence</div>
                <div class="eleve-agency-selector">
                  <Dropdown
                    v-model="this.selectedItem.agence"
                    :options="this.agences"
                    @change="patchEleve()"
                    optionLabel="nom"
                    id="agence"
                    name="agence"
                    :placeholder="this.selectedItem.agence.nom"
                    class="agency-dropdown"
                  />
                </div>

                <!-- CPF -->
                <button class="btn-cpf" @click="getDroitCpf()">
                  <svg width="16" height="16" fill="none" viewBox="0 0 24 24">
                    <path d="M12 2v20M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  Saisir un PAIEMENT CPF
                </button>

                <template v-if="showForm">
                  <div class="cpf-form">
                    <select class="filter-select" name="choice" v-model="postPaiement.choix">
                      <option value="" disabled>Droit CPF</option>
                      <template v-for="droit in droitCpf" :key="droit.id">
                        <option :value="droit.id">{{ droit.payeur }}</option>
                      </template>
                    </select>

                    <input type="date" class="cpf-input" v-model="postPaiement.date">
                    <input type="number" class="cpf-input" v-model="postPaiement.price">

                    <select class="filter-select" v-model="postPaiement.mode" @click="changeSelect()">
                      <option value="" disabled>Mode de paiement</option>
                      <option value="CHQ">CHQ</option>
                      <option value="VIR">VIR</option>
                    </select>

                    <button @click="postCpf" class="btn-cpf-ok">OK</button>
                  </div>
                </template>
              </div>
            </template>
          </template>

          <template v-if="showPaiement == true">
            <paiement :data="data" :modal="false" />
          </template>
        </div>

      </div>
    </main>

    <!-- Dialog contrat -->
    <Dialog v-model:visible="showMeContract" modal header="Contrat" :style="{ width: '50vw' }">
      <p class="resendMail">
        Vous n'avez pas reçu le mail ?
        <button @click="resendMail" class="btn-resend">Renvoyer le mail</button>
      </p>
      <div class="contract-code-row">
        <input type="number" name="code" placeholder="Saisir le code du mail" v-model="code" class="cpf-input">
        <button @click="signContract" class="btn-cpf-ok">Signer le contrat</button>
      </div>
    </Dialog>

    <template v-if="formModalSelected !== null">
      <FormulaireModal
        :formModalSelected="formModalSelected"
        :dossierFull="dossierFull"
        @selectFormModal="selectFormModal($event)"
      ></FormulaireModal>
    </template>
  </div>
</template>

<script>
import { useToast } from "primevue/usetoast";
import { FilterMatchMode } from "primevue/api";
import paiement from "@/components/eleve/Paiement.vue";
import FormulaireModal from "@/components/dossier/FormulaireModal.vue";
import SimpleTypeahead from 'vue3-simple-typeahead'
import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css'
import HeaderHome from "../../components/home/HeaderHome.vue";

export default {
  name: "App",
  components: {
    paiement,
    FormulaireModal,
    SimpleTypeahead,
    HeaderHome
  },
  data() {
    return {
      Elevesagence : [],
      changeTab : [],
      elevesEnregistrer: [],
      elevesAll : [],
      secComment: "",
      showRefusText: false,
      showContrat: false,

      utilisateurs: {
        id: null,
      },

      formModalSelected: false,
      dossierFull: null,

      libelleResultatExamCode: "",
      libelleResultatExamConduite: "",
      dateReussiteExaCode: "",
      dateReussiteExaConduite: "",
      elevesByAgence: [],
      nbrEchecExaCode: null,
      nbrEchecExaConduite: null,
      showPaiement: false,
      data: [],
      selectedAgence: null,
      selectedItem: null,
      toast: useToast(),
      examenDemande: {
        id: null,
      },
      filters: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      formExamen: {
        id: null,
        lieu: null,
        moniteur: null,
        dateStart: "",
        numero: "",
      },
      contract: [],
      contractData: "",
      fileList: [],
      putFile: false,
      checkContrat: false,
      questions: "",
      droitCpf : [],
      showForm : false,

      postPaiement : {
        date : "",
        price : 0,
        mode : "",
        payeur : "",
        choix : "",
      },

      dossier : {
        statut: "",
        step : "",
        code: "",
      },
      showMeContract : false,
      elevesName : [],
      cancelS : false,
      itemS : "",
      currentPage : 0,
      countEleves : 0,
      typeaheadKey : 0,
    };
  },
  mounted() {
    this.getNameEleve();
    this.getAgences();
    //this.getAllEleveAgence();

    if(this.$route.name == "AgenceEleveSelec"){
      // Un élève précis est demandé via l'URL (bouton ELEVE depuis le Dossier) : on ne charge
      // que lui. Appeler aussi getEleveAgence ici créait une race condition (les deux requêtes
      // partent en parallèle et celle qui répond en dernier écrase l'autre) — en local la requête
      // ciblée gagnait presque toujours, mais ça n'a rien de garanti : selon la latence réseau
      // du moment, c'est la liste complète non filtrée qui pouvait s'afficher à la place.
      let e = {};
      e.id = this.$route.params.id;
      this.selectItem(e);
    }else{
      this.getEleveAgence(0, 'null', 'null');
    }
  },
  methods: {

    goToDossier(){
      this.$store.commit("setEleveSelectAgence", this.selectedItem.id);
      this.$router.push({ name: "AgenceDossier" });
    },

    nextPage(offset){
      if(this.dossier.code != ""){
        this.dossier.step = "";
        this.dossier.statut = "";
        this.getEleveAgence(offset, "code", this.dossier.code);
      }
      if(this.dossier.statut != ""){
        this.dossier.step = "";
        this.dossier.code = "";
        this.getEleveAgence(offset, "dossier", this.dossier.statut);
      }
      if(this.dossier.step != ""){
        this.dossier.statut = "";
        this.dossier.code = "";
        this.getEleveAgence(offset, "form", this.dossier.step);
      }
    },

    cancelSearch(){
      this.getEleveAgence(0, "null", "null");
      this.dossier.step = "";
      this.dossier.statut = "";
      this.dossier.code = "";
      this.cancelS = false;
      this.itemS = "";
      this.currentPage = 0;
      this.typeaheadKey++;
    },

    selectItem(e){
      this.cancelS = true;
      this.itemS = e;
      window.api
        .get("/eleve/agence/"+this.$store.state.user.agence.id+"/"+e.id, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        })
        .then((response) => {
          this.Elevesagence = response.data.utilisateurs;
          this.elevesAll = response.data.utilisateurs;
          this.countEleves = response.data.utilisateurs.length;
          this.currentPage = 0;
        })
        .catch((error) => { console.log(error.response.data.message); });
    },

    getNameEleve(){
      window.api
        .get("/eleves/agence/name/"+ this.$store.state.user.agence.id, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        })
        .then((response) => { this.elevesName = response.data.utilisateurs; })
        .catch((error) => { console.log(error); });
    },

    onPaginate(e){
      if(this.dossier.step == "" && this.dossier.code == "" && this.dossier.statut == ""){
        this.dossier.step = "";
        this.dossier.code = "";
        this.dossier.statut = "";
        let offset = e.first;
        this.getEleveAgence(offset, "null", "null");
      }else{
        let offset = e.first;
        this.nextPage(offset);
      }
    },

    signContract(){
      if(parseInt(this.code) == this.selectedItem.newContractCode){
        window.api
          .patch(
            "/contracts/" + this.selectedItem.newContractId,
            { piece: {"status" : "valide", "code" : this.code, "date" : new Date().toLocaleDateString("fr")} },
            { headers: { Authorization: "Bearer " + this.$store.state.token, "Content-Type": "application/merge-patch+json" } }
          )
          .then(() => {
            this.selectedItem.newContract = "valide";
            this.showMeContract = false;
          })
          .catch((error) => {
            this.isWorkingValider = false;
            console.log(error);
          });
      }
    },

    resendMail(){
      window.api
        .get("/confirm/contract/"+ this.selectedItem.id, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        })
        .then(() => {})
        .catch((error) => { console.log(error); });
    },

    changeModeCode(){
      this.Elevesagence = this.elevesAll;
      if(this.dossier.code != ""){
        this.dossier.step = "";
        this.dossier.statut = "";
        this.getEleveAgence(0, "code", this.dossier.code);
        this.currentPage = 0;
      }else{
        this.dossier.step = "";
        this.dossier.statut = "";
        this.getEleveAgence(0, "null", "null");
        this.currentPage = 0;
      }
    },

    changeMode(){
      this.Elevesagence = this.elevesAll;
      if(this.dossier.statut != ""){
        this.dossier.step = "";
        this.dossier.code = "";
        this.getEleveAgence(0, "dossier", this.dossier.statut);
        this.currentPage = 0;
      }else{
        this.dossier.step = "";
        this.dossier.code = "";
        this.getEleveAgence(0, "null", "null");
        this.currentPage = 0;
      }
    },

    changeModeForm(){
      this.Elevesagence = this.elevesAll;
      if(this.dossier.step != ""){
        this.dossier.statut = "";
        this.dossier.code = "";
        this.getEleveAgence(0, "form", this.dossier.step);
        this.currentPage = 0;
      }else{
        this.dossier.statut = "";
        this.dossier.code = "";
        this.getEleveAgence(0, "null", "null");
        this.currentPage = 0;
      }
    },

    getEleveAgence(offset, mode, filtre) {
      window.api
        .get("/eleves/agence/" + this.$store.state.user.agence.id+"/"+offset + "/" + mode + "/" + filtre, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        })
        .then((response) => {
          this.Elevesagence = response.data.utilisateurs;
          this.elevesAll = response.data.utilisateurs;
          this.countEleves = response.data.count;
        })
        .catch((error) => { console.log(error.response.data.message); });
    },

    getAllEleveAgence() {
      window.api
        .get("/eleves/agence/" + this.$store.state.user.agence.id, {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        })
        .then((response) => {
          this.$store.commit("setAllElevePage", response.data.utilisateurs);
        })
        .catch((error) => { console.log(error.response.data.message); });
    },

    postCpf(){
      let droit = this.droitCpf.find(e => e.id == this.postPaiement.choix);
      let montant = droit.tot - this.postPaiement.price;
      if(montant < 0){ montant = 0; }

      window.api
        .put(
          "/other_paiements/"+droit.id,
          {
            eleve: "api/utilisateurs/" + this.selectedItem.id,
            description: "Droits CPF",
            totalAmount: montant * 100,
            mode: droit.mode,
            date: droit.date.date,
            payeur: droit.payeur,
            archive: false,
          },
          { headers: { Authorization: "Bearer " + this.$store.state.token } }
        )
        .then(() => {
          window.api
            .post(
              "/other_paiements",
              {
                otherPaiementC: "api/other_paiements/" + droit.id,
                eleve: "api/utilisateurs/" + this.selectedItem.id,
                description: "Acpte CPF",
                totalAmount: this.postPaiement.price * 100,
                mode: this.postPaiement.mode,
                date: this.postPaiement.date,
                payeur: this.postPaiement.payeur,
                archive: false,
              },
              { headers: { Authorization: "Bearer " + this.$store.state.token } }
            )
            .then(() => { this.checkPaiement(); })
            .catch((error) => { console.log(error); });
        })
        .catch((error) => { console.log(error); });
    },

    getDroitCpf(){
      if(!this.showForm){
        window.api.get("/eleve/check/paiement/" + this.selectedItem.id, {
          headers: { "Authorization": "Bearer " + this.$store.state.token }
        }).then(response => {
          this.droitCpf = response.data.droitCpf;
          if(this.droitCpf.length != 0){ 
            this.showForm = true; 
          }else{
            alert("Cet élève n'a pas de paiement CPF");
          }
        }).catch(error => { console.log(error) });
      }else{
        this.showForm = false;
        this.postPaiement.date = "";
        this.postPaiement.price = 0;
        this.postPaiement.mode = "";
        this.postPaiement.payeur = "";
        this.postPaiement.choix = "";
      }
    },

    validFormContract() {
      let inputs = document.querySelectorAll("#questionCont");
      let responseContract = [];
      let countTot = 0;
      inputs.forEach((input) => {
        if (input.checked) {
          responseContract.push(parseInt(input.attributes[2].value));
          countTot = countTot + parseInt(input.attributes[2].value);
        } else {
          responseContract.push(0);
        }
      });
      responseContract.push(countTot);
      if (countTot <= 3) { responseContract.push([20, 40]); }
      else if (countTot > 3 && countTot <= 7) { responseContract.push([15, 35]); }
      else if (countTot > 7 && countTot <= 10) { responseContract.push([10, 20]); }

      window.api
        .post(
          "/contracts",
          { eleve: "api/utilisateurs/" + this.selectedItem.id, question: responseContract },
          { headers: { Authorization: "Bearer " + this.$store.state.token } }
        )
        .then(() => { this.showContrats(); })
        .catch((error) => { console.log(error); });
    },

    savePiece(e) {
      let piece = "";
      if (this.fileList.length == 0) { piece = this.selectedItem.contrat.piece; }
      else { piece = this.fileList; }
      let status = e.target.textContent == "VALIDER" ? "Validé" : "Refusé";

      if (this.contract.contractEleve.length == 0) {
        window.api
          .post("/contracts", { piece, status, eleve: "api/utilisateurs/" + this.selectedItem.id },
            { headers: { Authorization: "Bearer " + this.$store.state.token } })
          .then(() => {
            const type = status == "Validé" ? "contrat valide" : "contrat refuse";
            window.api.post("/sendMail", { type, email: this.selectedItem.email },
              { headers: { Authorization: "Bearer " + this.$store.state.token } })
              .then(() => { this.showContrats(); location.reload(); })
              .catch((error) => { console.log(error); });
          })
          .catch((error) => { console.log(error); });
      } else {
        window.api
          .put("/contracts/" + this.contract.contractEleve[0].id,
            { piece, status, eleve: "api/utilisateurs/" + this.selectedItem.id, secComment: this.secComment },
            { headers: { Authorization: "Bearer " + this.$store.state.token } })
          .then(() => {
            const type = status == "Validé" ? "contrat valide" : "contrat refuse";
            window.api.post("/sendMail", { type, email: this.selectedItem.email },
              { headers: { Authorization: "Bearer " + this.$store.state.token } })
              .then(() => { this.showContrats(); this.setComment = ""; this.showRefusText = false; location.reload(); })
              .catch((error) => { console.log(error); });
          })
          .catch((error) => { console.log(error); });
      }
    },

    addFile() {
      this.fileList = [];
      let input = document.getElementById("file_input_cont");
      const reader = new FileReader();
      reader.onloadend = () => {
        this.fileList.push({ file_name: input.files[0].name, file_data: reader.result });
      };
      reader.readAsDataURL(input.files[0]);
      this.putFile = true;
      this.checkContrat = true;
    },

    showContrats() { this.showMeContract = true; },

    solde() {
      this.showPaiement = true;
      this.data = this.selectedItem;
    },

    patchEleve() {
      const agenceVal = this.selectedItem.agence.nom === "non rattaché"
        ? { agence: "null" }
        : { agence: this.selectedItem.agence.id };

      window.api
        .patch(`utilisateur/` + this.selectedItem.id, agenceVal, {
          headers: { Authorization: "Bearer " + this.$store.state.token, "Content-Type": "application/merge-patch+json" },
        })
        .then((response) => {
          this.toast.add({ severity: "success", summary: "Agence modifié", detail: "l'agence lié à l'élève été modifié avec succès", life: 3000 });
          console.log("completed", response.data);
          this.getEleveAgence(0, "null", "null");
          this.dossier.step = "";
          this.dossier.code = "";
          this.dossier.statut = "";
          this.selectedItem = null;
        })
        .catch((error) => { console.log("ERRR::", error.response.data); });
    },

    refreshOnDeleteOrArchiveEleve(id) {
      this.Elevesagence = this.Elevesagence.filter((e) => e.id !== id);
    },

    async getAgences() {
      try {
        window.api.get("/getAllAgences", { headers: { Authorization: "Bearer " + this.$store.state.token } })
          .then((res) => {
            this.agences = res.data.Agences;
            this.agences.push({ nom: "non rattaché" });
          });
      } catch (e) {console.log(e)}
    },

    paiement(e) {
      this.data = e;
      this.showPaiement = true;
    },

    selectFormModal() {
      if (this.formModalSelected) {
        this.formModalSelected = false;
        this.dossierFull = null;
      } else {
        this.formModalSelected = true;
        if (this.selectedItem.Dossier.id !== undefined) {
          window.api
            .get("/dossiers/" + this.selectedItem.Dossier.id, { headers: { Authorization: "Bearer " + this.$store.state.token } })
            .then((response) => {
              this.dossierFull = {
                id: this.selectedItem.id, nom: this.selectedItem.nom, prenom: this.selectedItem.prenom,
                telephone: this.selectedItem.telephone, mailEleve: this.selectedItem.email, dossier: response.data,
              };
            })
            .catch((error) => { console.log(error.response.data.message); });
        } else {
          this.dossierFull = {
            id: this.selectedItem.id, nom: this.selectedItem.nom, prenom: this.selectedItem.prenom,
            telephone: this.selectedItem.telephone, mailEleve: this.selectedItem.email,
            dossier: {
              nomUsage: "", autresPrenom: "", telParent: "", mailParent: "", adresse: "", codePostal: "", ville: "",
              dateNaissance: "", paysNaissance: "", depNaissance: "", villeNaissance: "", nationaliteFR: "null",
              parlerFRCouramment: "null", vehiculeAmenage: "null", lunettes: "null", permis: "null", faitSuite: "null",
              motifAlcoolStup: "null", prevoitAac: "null", social: "null", metier: "", lycee: "null", autreLycee: "",
              numNeph: "",
            },
          };
        }
      }
    },

    onSelected() {
      if (this.selectedItem != null) {
        this.showPaiement = false;
        this.showForm = false;
      }
    },

    async deleteUtilisateur(id) {
      let eleve = this.Elevesagence.find((e) => e.id = id);
      if (eleve.montantTotal == "" || eleve.montantTotal == 0) {
        try {
          if (confirm("Voulez vous vraiment supprimer ?")) {
            window.api
              .delete("utilisateurs/" + id, { headers: { Authorization: "Bearer " + this.$store.state.token } })
              .then((response) => {
                this.toast.add({ severity: "success", summary: "Eleve supprimé", detail: "Votre eleve à été supprimé avec succès", life: 3000 });
                this.getEleveAgence(0, "null", "null");
                this.dossier.step = ""; this.dossier.code = ""; this.dossier.statut = "";
                console.log(response);
              });
          }
        } catch (e) {console.log(e)}
      } else {
        this.toast.add({ severity: "warn", summary: "Cette eleve ne peut pas être supprimé", detail: "Cette eleve a au moins un paiement", life: 3000 });
      }
    },

    async archiveEleve(id) {
      try {
        if (confirm("Voulez vous vraiment Archiver cette eleve ?")) {
          window.api
            .patch("utilisateur/" + id, { active: false }, { headers: { Authorization: "Bearer " + this.$store.state.token } })
            .then((response) => {
              this.toast.add({ severity: "success", summary: "Eleve archivé", detail: "Votre eleve à été archivé avec succès", life: 3000 });
              this.getEleveAgence(0, "null", "null");
              this.dossier.step = ""; this.dossier.code = ""; this.dossier.statut = "";
              console.log(response);
            });
        }
      } catch (e) {console.log(e)}
    },

    onSubmit() { this.creerExamen(); },

    closeModal(e) {
      if (e.target.id == "closeCreationExam") {
        document.getElementById("myModalCreationExam").style.display = "none";
      }
    },

    async getEleveById(eleve) {
      document.getElementById("myModalCreationExam").style.display = "block";
      window.api
        .get(`/utilisateur/` + eleve.id, { headers: { Authorization: "Bearer " + this.$store.state.token } })
        .then((result) => {
          this.utilisateurs = result.data.utilisateur[0];
          this.utilisateurs.id = eleve.id;
        })
        .catch((error) => { console.log("ERRR::", error.result.data); });
    },

    async getExamenDemandeByEleve(id) {
      window.api
        .get(`/getExamenDemandeByEleve/` + id, { headers: { Authorization: "Bearer " + this.$store.state.token } })
        .then((result) => {
          this.examenDemande = result.data.ExamenDemande;
          this.examenDemande.id = result.data.ExamenDemande[this.examenDemande.length - 1].id;
          this.putExamenDemande(this.examenDemande.id);
        })
        .catch((error) => { console.log("ERRR::", error.result.data); });
    },
  },
  computed: {
    lieus() { return this.$store.state.lieus; },
    moniteurs() { return this.$store.state.moniteurs; },
  },
};
</script>

<style scoped>
*, *::before, *::after { box-sizing: border-box; }

div#conteneurEleve{
  background-color: #F4F6F9;
  min-height: 100vh;
  padding-bottom: 1rem;
}


/* ===================== PAGE MAIN ===================== */
.page-main {
  width: 90%;
  margin: 0 auto;
  padding: 40px 40px;
  text-align: left;
}

.page-header {
  margin-bottom: 32px;
}

.page-title {
  font-size: 30px;
  font-weight: bold;
  color: #1a1f2e;
  letter-spacing: -0.5px;
  margin-bottom: 4px;
}

.page-subtitle {
  font-size: 14px;
  color: #64748b;
  margin: 0;
}

/* ===================== LAYOUT ===================== */
.eleves-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  align-items: start;
}

/* ===================== FILTERS ===================== */
.eleves-filters {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
  align-items: center;
  flex-wrap: wrap;
}

.eleves-search {
  flex: 1;
  min-width: 200px;
}

.search-wrap {
  position: relative;
}

.search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #94a3b8;
  pointer-events: none;
  z-index: 1;
}

.search-input {
  width: 100%;
  padding: 11px 14px 11px 40px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  background: #ffffff;
  color: #1a1f2e;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.search-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.08);
}

.filter-select {
  padding: 10px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 13px;
  background: #ffffff;
  color: #1a1f2e;
  outline: none;
  cursor: pointer;
  transition: border-color 0.15s;
  min-width: 110px;
}
.filter-select:focus { border-color: #3b82f6; }

.btn-archive-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  background: #1a9e6e;
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.15s;
  white-space: nowrap;
  text-decoration: none;
}
.btn-archive-toggle:hover { background: #0d7a54; color: #ffffff; }

.btn-cancel {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 14px;
  background: #fff1f2;
  color: #f43f5e;
  font-size: 13px;
  font-weight: 600;
  border: 1px solid rgba(244, 63, 94, 0.2);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.15s;
}
.btn-cancel:hover { background: #ffdde3; }

/* ===================== TABLE ===================== */
.table-wrap {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
  overflow-x: auto;
}

.table-paginator {
  border-top: 1px solid #e2e8f0;
}

.row-del-btn {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 1.5px solid #e2e8f0;
  background: #ffffff;
  color: #94a3b8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s;
}
.row-del-btn:hover {
  background: #fff1f2;
  border-color: #f43f5e;
  color: #f43f5e;
}

/* ===================== DETAIL PANEL ===================== */
.eleve-detail-panel {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  overflow: hidden;
  position: sticky;
  top: 80px;
  width: 100%;
}

.eleve-detail-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  color: #94a3b8;
  font-size: 14px;
  line-height: 1.6;
}

.eleve-detail-head {
  padding: 20px 20px 16px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8f9fa;
}

.eleve-detail-head-top {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
}

.eleve-avatar {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #1a9e6e, #0d7a54);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  flex-shrink: 0;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.eleve-detail-name-block {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.eleve-detail-name {
  font-size: 18px;
  font-weight: 400;
  color: #1a1f2e;
}

.eleve-detail-phone {
  font-size: 12px;
  color: #64748b;
}

.eleve-detail-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

/* Tags */
.tag {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 4px 10px;
  border-radius: 6px;
}
.tag-green  { background: #e8f7f1; color: #1a9e6e; }
.tag-red    { background: #fff1f2; color: #f43f5e; }
.tag-amber  { background: #fef3c7; color: #b45309; }
.tag-blue   { background: #eff6ff; color: #3b82f6; }
.tag-purple { background: #f5f3ff; color: #5b21b6; }
.tag-pink   { background: #fdf2f8; color: #db2777; }

/* Body */
.eleve-detail-body {
  padding: 20px;
}

.eleve-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 4px;
}

.eleve-info-item {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.info-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  color: #94a3b8;
}

.eleve-info-val {
  font-size: 13px;
  color: #1a1f2e;
  font-weight: 500;
  word-break: break-all;
}

.eleve-section-title {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 8px;
  margin-top: 20px;
}

/* Actions */
.eleve-actions-grid {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.action-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 14px;
  border: none;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  width: 100%;
}

.action-btn--blue  { background: #eff6ff; color: #3b82f6; }
.action-btn--blue:hover  { background: #dbeafe; }
.action-btn--teal  { background: #e8f7f1; color: #1a9e6e; }
.action-btn--teal:hover  { background: #c3ead9; }
.action-btn--amber { background: #fef3c7; color: #b45309; }
.action-btn--amber:hover { background: #fde68a; }

/* Agency */
.eleve-agency-selector { margin-top: 8px; }

.agency-dropdown {
  width: 100%;
  font-size: 13px;
}

/* CPF */
.btn-cpf {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 0;
  width: 100%;
  background: #3b82f6;
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.15s;
  letter-spacing: 0.02em;
  margin-top: 20px;
}
.btn-cpf:hover {
  background: #2563eb;
  transform: translateY(-1px);
}

.cpf-form {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 12px;
}

.cpf-input {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 13px;
  background: #f4f6f9;
  color: #1a1f2e;
  outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
}
.cpf-input:focus {
  border-color: #1a9e6e;
  box-shadow: 0 0 0 3px rgba(26, 158, 110, 0.1);
  background: #ffffff;
}

.btn-cpf-ok {
  padding: 10px 20px;
  background: linear-gradient(135deg, #1a9e6e, #0d7a54);
  color: #ffffff;
  font-size: 13px;
  font-weight: 700;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.15s;
}
.btn-cpf-ok:hover { transform: translateY(-1px); }

/* Contract dialog */
.resendMail {
  font-size: 14px;
  color: #64748b;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.btn-resend {
  padding: 6px 14px;
  background: #eff6ff;
  color: #3b82f6;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid rgba(59, 130, 246, 0.2);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
}
.btn-resend:hover { background: #dbeafe; }

.contract-code-row {
  display: flex;
  gap: 10px;
  align-items: center;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 900px) {
  .app-nav { padding: 0 20px; }
  .page-main { width: 100%; padding: 24px 20px; }

  .eleves-layout {
    grid-template-columns: 1fr;
    /* empêche le grid de s'étirer au-delà du viewport */
    min-width: 0;
    max-width: 100%;
  }

  /* grid item : min-width: 0 est indispensable pour contenir le DataTable */
  .eleves-left {
    min-width: 0;
    max-width: 100%;
  }

  .table-wrap {
    min-width: 0;
    max-width: 100%;
    overflow-x: auto; /* le tableau scrolle dans son conteneur */
  }

  /* Le panel détail n'est plus sticky sur tablette */
  .eleve-detail-panel { position: static; }
}

@media (max-width: 640px) {
  .page-main {
    padding: 16px 14px;
  }

  .page-title {
    font-size: 22px;
  }

  .page-subtitle {
    font-size: 13px;
  }

  /* Filters : chaque select prend la moitié de la ligne */
  .eleves-filters {
    gap: 8px;
  }

  .filter-select {
    flex: 1 1 calc(50% - 4px);
    min-width: 0;
  }

  .eleves-search {
    flex: 1 1 100%;
  }

  .btn-cancel,
  .btn-archive-toggle {
    flex: 1 1 calc(50% - 4px);
    justify-content: center;
  }

  /* Info grid en 1 colonne */
  .eleve-info-grid {
    grid-template-columns: 1fr;
  }

  /* Dialog contrat */
  .contract-code-row {
    flex-direction: column;
    align-items: stretch;
  }

  .resendMail {
    flex-wrap: wrap;
    gap: 8px;
  }

  /* Liste typeahead full width */
  .simple-typeahead :deep(.simple-typeahead-list) {
    width: 100%;
  }
}

a { text-decoration: none; }

:deep(#typeahead_id) {
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 10px;
  width: 100%;
}

.simple-typeahead :deep(.simple-typeahead-list) {
  position: absolute;
  z-index: 9999;

  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-height: 300px;
  overflow-y: auto;
  margin: 0;
  padding: 0;
  list-style: none;
  width: 40%;
}

.simple-typeahead :deep(.simple-typeahead-list-item) {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
}

.simple-typeahead :deep(.simple-typeahead-list-item:hover),
.simple-typeahead
  :deep(.simple-typeahead-list-item.simple-typeahead-list-item-active) {
  background-color: #f0f4ff;
}
</style>